import React, { useState } from "react";
import { usePost } from "utils/api";
import { useQuery } from "utils/gql";
import { toast } from "react-toastify";
import { showResponseMessage } from "utils/message";
import View from "components/crh/offices/Form.view";

function FormSave({ refresh, setIsVisible }) {

    const [error, setError] = useState(null);
    const [reset, setReset] = useState(() => { });
    const [refreshValue, setRefreshValue] = useState(null);

    if (refresh !== refreshValue) {
        setRefreshValue(refresh);
    }

    const reqGropus = useQuery(`
        Group {
          result {
            id
            key
            description
            abbreviation
          }
        }
      `, {
        order: [
          ["description", "ASC"]
        ]
    });

    const [callSave, reqSave] = usePost("/offices", {
        onCompleted: () => {
            if (!toast.isActive("office-created"))
                toast.success("Sucursal creada correctamente", { toastId: "office-created" });

            setIsVisible(false);
            reset();
        },
        onError: (error) => {
            console.error(error)
            showResponseMessage(error.status, "offices", "sucursales", "create")
        }
    })

    const onSubmit = (values, { resetForm }) => {

        for (let key in values)
            if (values[key] === "")
                values[key] = null

        const { key, description, abbreviation } = values
        if (!key || !description || !abbreviation) {
            toast.error("Todos los campos son obligatorios");
            return;
        }

        setReset(() => () => resetForm({}));
        callSave(values);

    }

    const onCancel = (resetForm) => {
        setIsVisible(false);
        resetForm({});
    }

    const groups = reqGropus.data?.result || [];

    return (
        <View
            groups={groups}
            onSubmit={onSubmit}
            onCancel={onCancel}
            error={error}
            setIsVisible={setIsVisible}
            setError={setError}
        />
    )
}

export default FormSave;